import { shared } from './shared'
import type { Schema } from './types'

export const schema: Schema = {
  ...shared,
  'work-create-project': {
    default: true,
  },
  'editor-enable-layouts': {
    default: true,
  },
}
